//language=CSS
import {css} from 'lit';

export const styles = css`
        :host {
            position: relative;
            display: block;
        }
        
        .dropzone-container {
            position: relative;
        }
        
        .container {
            position: relative;
            display: grid;
            width: 100%;
            overflow: hidden;
            grid-template-columns: auto var(--sp-image-input-button-width, 90px);
            grid-column-gap: var(--sp-default-gap);
            grid-row-gap: calc(var(--sp-default-padding) / 2);
            padding-bottom: 2px;
        }
        
        .container.bubble {
            grid-auto-flow: row;
            grid-template-columns: 100%;
            height: unset;
        }

        .view-mode > sp-image-input-entry:first-child {
            grid-column: 1 / 3;
        }
        .view-mode > sp-image-input-entry:first-child::part(placeholder) {
            cursor: default;
            pointer-events: none;
        }
        .view-mode .buttons {
            display: none;
        }
        
        sp-image-input-entry::part(placeholder) {
            background-size: auto 60%;
        }
        
        .buttons {
            display: grid;
            position: relative;
            grid-auto-flow: row;
            height: 100%;
        }
        
        .buttons.bubble {
            grid-auto-flow: column;
            grid-column-gap: var(--sp-default-gap);
            place-content: center;
            height: unset;
        }
        
        .buttons:not(.bubble) :nth-child(3) {
            margin-top: var(--sp-default-gap);
        }
        
        .gallery {
            display: grid;
            position: relative;
            grid-column: 1 / 3;
            grid-gap: var(--sp-default-gap);
        }
        
        .gallery sp-image-input-entry {
            aspect-ratio: 1 / 1;
        }
        
        .gallery.bubble {
            grid-column: 1 / 2;
        }
        
        .gallery sp-image-input-entry::part(placeholder) {
            background-size: auto 50%;
        }
        
        .gallery .placeholder ~ .placeholder::part(placeholder)  {
            background-color: rgb(var(--sp-greyborder));
            pointer-events: none;
        }
        
        sp-button {
            width: 100%;
            height: auto;
        }
        
        .delete-zone {
            position: absolute;
            height: 100%;
            width: 100%;
        }
        
        .delete-zone::part(container) {
            --sp-drop-zone-background-color: rgba(var(--sp-greyborder), 0.8);
            --sp-drop-zone-background-color-active: rgba(var(--sp-greymedium), 0.8);
            --sp-drop-zone-border-color: rgba(var(--sp-greydark));
            --sp-drop-zone-border-color-active: rgba(var(--sp-greydark));
        }
        .delete-zone::part(icon) {
            background-size: 40%;
        }
        
        #image-input-entry-0, #image-input-entry-preview {
            width: 100%;
            aspect-ratio: 2 / 1;
        }
        
        .bubble #image-input-entry-0, .bubble #image-input-entry-preview {
            aspect-ratio: 1 / 1;
        }

        /* This is a best effort approach for legacy browsers where heights are hardcoded */
        @supports not (aspect-ratio: 1) {
            .gallery sp-image-input-entry {
                height: 110px;
            }
            
            #image-input-entry-0, #image-input-entry-preview {
                height: 14.8rem;
            }

            .bubble #image-input-entry-0, .bubble #image-input-entry-preview {
                height: 8rem;
            }
        }
        
        sp-field-container {
            padding:0;
            margin: 10px 0 0 0;
        }
    `;